function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 183 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M167.743 112.556C168.603 113.25 169.862 113.116 170.556 112.257L181.866 98.2536C182.56 97.3943 182.426 96.1351 181.567 95.4411C180.707 94.747 179.448 94.881 178.754 95.7403L168.701 108.187L156.254 98.1341C155.394 97.4401 154.135 97.5741 153.441 98.4334C152.747 99.2927 152.881 100.552 153.74 101.246L167.743 112.556ZM1.29935 5.99741C26.7373 2.14661 65.5648 2.83908 99.3185 17.337C132.941 31.7786 161.552 59.9031 167.011 111.212L170.989 110.788C165.356 57.8463 135.657 28.5919 100.897 13.6617C66.2682 -1.21214 26.6413 -1.88444 0.70065 2.04247L1.29935 5.99741Z",
    fill: "currentColor"
  }));
};
export default SvgArrow;